import { createContext } from "react";
import { IContextDriver } from "../types/driver.interface";

const DriverScreen = createContext<IContextDriver>({});

export default DriverScreen;
